import { useMutation, useQueryClient } from '@tanstack/react-query'
import { throwIfApiError } from 'utils/error-handling/throwifApiError'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { UpdateTableFilterPathParameters, UpdateTableFilterRequest } from '@omnea-app/org-settings/orgSettingsFrontendClient'
import { OrgSettingsHttpClient, OrganisationSettingsResponse } from '@omnea-app/org-settings/orgSettingsHttpClient'
import { tableFiltersQueryKey, tableFiltersQueryKeys } from './tableFiltersQueryKeys'

export type UpdateTableFilterResponse = OrganisationSettingsResponse<'/table-filters/{id}/update', 'post'>

export const useUpdateTableFilter = () => {
  const queryClient = useQueryClient()
  const { getToken } = useAuthenticatedUser()

  return useMutation<
    UpdateTableFilterResponse['data'],
    UpdateTableFilterResponse['error'],
    { body: UpdateTableFilterRequest; pathParams: UpdateTableFilterPathParameters }
  >({
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({ queryKey: [tableFiltersQueryKey, 'filter'] })
      void queryClient.invalidateQueries({ queryKey: tableFiltersQueryKeys.getTableFilterById(variables.pathParams.id) })
    },
    mutationFn: async (request) => {
      const authorization = await getToken()
      const orgSettingsClient = new OrgSettingsHttpClient({ authorization })
      const { data, error } = await orgSettingsClient.POST('/table-filters/{id}/update', {
        params: { path: request.pathParams },
        body: request.body,
      })
      throwIfApiError(error)
      return data
    },
  })
}
